import showOpenCover from './showOpenCover';
import showOpenTip from './showOpenTip';
import showPs from './showPs';
import vrModel from './vrModel';
import model3d from './model3d';
import videoModal from './videoModal';
import iframeModal from './iframeModal';
import hotspot from './hotspot';
import article from './articleModal';
import swiper from './swiperModal';
import rings from './ringsModal';
import showPanoinfo from './showPanoinfo';
// import comment from './comment';
import qrcode from './qrcodeModal';
import textScroll from './textScroll';
import phone from './phone';
import link from './link';
import music from './music';
import scene from './scene';
import sceneList from './sceneList';
import detailsList from './detailsList';
import ui from './ui';
import richTextModal from './richTextModal';
import navigation from './navigation';
export default {
  showOpenTip,
  showOpenCover,
  showPanoinfo,
  // ...comment,
  ...showPs,
  ...vrModel,
  ...model3d,
  ...videoModal,
  ...iframeModal,
  ...hotspot,
  ...article,
  ...swiper,
  ...rings,
  ...qrcode,
  ...textScroll,
  ...phone,
  ...link,
  ...music,
  ...scene,
  ...sceneList,
  ...detailsList,
  ...ui,
  ...richTextModal,
  ...navigation
};
